import React, {useState} from 'react';
import ArrNavigationList, {
  NavigationListItem,
} from '../../../components/common/arr-navigation-list/ArrNavigationList';
import {Box, Typography} from '@mui/material';
import {ReactComponent as DeleteIcon} from '../../../assets/images/delete.svg';

const initialItems: NavigationListItem[] = [
  {
    id: '1',
    label: 'Project Alpha',
    route: '/projects/alpha',
    canViewAction: true,
    actionIcon: 'delete',
  },
  {
    id: '2',
    label: 'Project Beta',
    route: '/projects/beta',
    disabled: false,
    canViewAction: true,
    actionIcon: 'delete',
  },
  {
    id: '3',
    label: 'Project Gamma',
    route: '/projects/gamma',
    disabled: true,
    canViewAction: false,
    actionIcon: 'delete',
  },
  {
    id: '4',
    label: 'Project Delta',
    route: '/projects/delta',
    disabled: false,
    canViewAction: true,
    actionIcon: 'delete',
  },
  {
    id: '5',
    label: 'Project Sigma',
    route: '/projects/sigma',
    disabled: true,
    canViewAction: true,
    actionIcon: 'delete',
  },
];

const NavigationListDemo: React.FC = () => {
  const [items, setItems] = useState(initialItems);

  const handleNavigate = (item: NavigationListItem) => {
    alert(`Navigate to: ${item?.route || item?.label}`);
  };

  const handleAction = (itemId: string) => {
    setItems((prev) => prev?.filter((item) => item?.id !== itemId));
  };

  const actionLabel = 'Delete item';

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        ArrNavigationList Demo
      </Typography>
      <ArrNavigationList
        items={items}
        onNavigate={handleNavigate}
        onAction={handleAction}
        actionLabel={actionLabel}
        actionIcon={<DeleteIcon />}
      />
    </Box>
  );
};

export default NavigationListDemo;
